<script>
import MixedGridFiltersItemList from '@phoenix/mixins/components/mixedGrid/MixedGridFiltersItemList';
import PictureLazy from '@maison/components/common/PictureLazy';

export default {
  components: {
    PictureLazy,
  },

  mixins: [MixedGridFiltersItemList],

  inject: {
    customFilters: {
      default: () => ({}),
    },
    countByFilters: {
      default: () => ({}),
    },
  },

  props: {
    displayCount: {
      type: Boolean,
      default: true,
    },
  },

  emits: ['onItemSelected'],

  methods: {
    getItemClasses(item) {
      return ['field field--switch field--custom-label', { 'field--disabled': this.itemIsGreyedOut(item) }];
    },

    getInputId(item) {
      return `filtersub-desktop-${this.filter.id}-${item.value}`;
    },

    hasImage(item) {
      return (
        this.customFilters?.[this.filter.name] &&
        (this.customFilters[this.filter.name]?.defaultImage || this.customFilters[this.filter.name]?.[item.valueName])
      );
    },

    itemImage(item) {
      return (
        this.customFilters[this.filter.name]?.items?.[item.valueName]?.image ??
        this.customFilters[this.filter.name].defaultImage
      );
    },

    displayItemCount(item) {
      return this.displayCount && this.itemCount(item) !== null;
    },

    itemIsDisabled(item) {
      return (
        item.disabled === true ||
        (this.itemCount(item) === 0 &&
          // Always let the user uncheck an empty filter
          !this.itemIsActive(item))
      );
    },

    itemCount(item) {
      if (Object.hasOwn(item, 'count')) {
        return item.count;
      }

      if (this.countByFilters && this.countByFilters[this.filter.id]) {
        return (
          this.countByFilters[this.filter.id].find((filterItem) => filterItem.value === item.value)?.nbrProducts ?? 0
        );
      }

      return null;
    },
  },
};
</script>

<template>
  <fieldset class="fieldset fieldset--vertical" data-cy="mixed-grid-filter-list">
    <div class="fieldset__fields">
      <div v-for="item in filter.items" :key="item.value" :class="getItemClasses(item)">
        <input
          :id="getInputId(item)"
          :checked="itemIsActive(item)"
          :data-cy="getInputId(item)"
          :data-property="filter.id"
          :data-value="item.value"
          :disabled="itemIsDisabled(item)"
          :name="getInputId(item)"
          :value="item.value"
          class="switch"
          type="checkbox"
          @change="$emit('onItemSelected', filter.id, item.value)"
        />

        <label :for="getInputId(item)" class="label">
          <div v-if="hasImage(item)" class="picture field--custom-label__picture">
            <picture-lazy v-bind="itemImage(item)" />
          </div>

          <span>{{ item.label }}</span>

          <span v-if="displayItemCount(item)" class="products-filters-panel__facet"> ({{ itemCount(item) }}) </span>
        </label>
      </div>
    </div>
  </fieldset>
</template>
